import LogOutLink from "../LogOutLink";
import Layout from "./Layout";

export default function NotAnAdmin(): JSX.Element {
  return (
    <Layout title="Account Deactivated">
      <p>
        Your account has been deactivated. Please contact your administrator if
        you beleive this was done in error.
      </p>
      <LogOutLink />
    </Layout>
  );
}
